module.exports = __webpack_public_path__ + "img/arrow.5deb8aed.svg";